export default "__VITE_ASSET__BNCjeFJu__"